module.exports = __webpack_public_path__ + "TiemposFine-Medium.svg?ce55df8b14f798bb5278838667b5aec8";